import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'

// "use strict";

// Tipos de OS
const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.codigoTipoCliente} dato2={props.elemento.descrTipoCliente} value={props.elemento._id}>{props.elemento.codigoTipoCliente} ={">"} {props.elemento.descrTipoCliente}</option>
  )
};

const ListaTipo = ({styles, handleChange, list}) => {
    const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="tipocl" id="miLista" onChange={(ev)=>handleChange(ev)}>
          <option style={styles.input} value="">Seleccionar...</option>
          {NivelDetalleTipo}
        </select>
      </div>
    )
};

//Ajustes
const DetAjustes = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
    </tr>
  )
};

const ListaClientes = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetAjustes elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcAdmTC extends React.Component {
  state={codigoTipoCliente: "", descrTipoCliente: "Seleccionar...",
    listArchivo: [], permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  //ACTUALIZAR BD
  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({variables: args});

      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }
  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){argsCrud[i]._id = codigo}
    }
    for(let i=1; i<totDocCRUD; i++){await this.crudBD(crudColecc[i], argsCrud[i], i)}
    console.log("final")
  }

  handleChange = async (ev) => {
    // console.log(ev.target.name, ev.target.value)
    const updState = (listArchivo) => {
      this.setState({listArchivo, errors: []})
    };

    if(ev.target.name === "tipocl"){
      let codigoTipoCliente="", descrTipoCliente="Seleccionar..."
      let miLista = document.getElementById("miLista");
      if(ev.target.value&&ev.target.value!=="Seleccionar..."){
        codigoTipoCliente = miLista.options[miLista.selectedIndex].attributes[0].value
        descrTipoCliente = miLista.options[miLista.selectedIndex].attributes[1].value
      }
      this.setState({codigoTipoCliente, descrTipoCliente})
    }
    // if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"||ev.target.name === "tipocl"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let lista4 = []
        if(this.props.lista4){
          lista4 = await this.props.lista4
        }
        let descrTipoCliente = this.state.descrTipoCliente
        let archcsv = ""
        // console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()
          //guardar en array lines, cada linea del archivo
          let lines = archivo.split(/\n/)
          let numLineas = 0, linea = 0, listArchivo = []
          lines.forEach(line => {
            if(line&&(numLineas>0||(numLineas===0&&!checkTieneEncab))){
              linea += 1
              //crear array de campos para cada linea
              let campos = line.split(";")
              let contrato = campos[0]
              contrato = contrato.replace('\r', '');

              if(lista4.length>0&&descrTipoCliente!=="Seleccionar..."){
                listArchivo.push({linea, contrato})
              }
            }
            numLineas += 1
          })
          updState(listArchivo)
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
      }else{
        this.setState({listArchivo: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listArchivo)=>{
    let errors = []
    if(listArchivo.length===0){
      errors.push({path: "Clientes", message: "No hay clientes"});
    }
    if(this.state.descrTipoCliente==="Seleccionar..."){
      errors.push({path: "descrTipoCliente", message: "Por favor seleccione el Tipo de cliente"});
    }
    // console.log(listArchivo.length)
    document.body.style.cursor = 'wait'
    let actCli = [], actCliMany = [], actCliMany1 = []
    let argsUpd = {}
    for(let ii=0; ii<listArchivo.length; ii++){
      let elemento = listArchivo[ii]
      // console.log(ii, elemento.contrato)
      if(!elemento.contrato){
        errors.push({path: "Clientes", message: `Datos inválidos en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}, Nodo: ${elemento.descrNodo}`});
      }
      argsUpd = {
        "tipoAct": "EditarTipoCliente",
        "contrato": listArchivo[ii].contrato,
        "tipocl": {codigoTipoCliente: this.state.codigoTipoCliente, descrTipoCliente: this.state.descrTipoCliente},
      }
      actCli.push(argsUpd)
    }
    actCli.forEach((elemento, ii) => {
      actCliMany.push(elemento)
    })
    actCliMany1.push({cliente: actCliMany})

    let numDocCRUD = 0, totDocCRUD = 1
    let argsCrud = [], crudColecc = []
    for(let iii=0; iii<totDocCRUD; iii++){
      argsCrud.push({ctrlCampo: 'NO_CRUD'})
    }
    for(let iii=0; iii<totDocCRUD; iii++){
      crudColecc.push(this.props.editClienteMany)
    }

    argsCrud[numDocCRUD] = actCliMany1[0]
    argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
    argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
    crudColecc[numDocCRUD] = this.props.editClienteMany

    await this.updColecc(crudColecc, argsCrud, totDocCRUD)

    document.body.style.cursor = 'default'
    // console.log(errors.length)
    this.setState({errors})
    this.setState({listArchivo: []})
    
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){

  }

  render(){
    const {descrTipoCliente, listArchivo, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let lista = []
    if(this.props.lista4){lista = this.props.lista4}

    let mensaje = "Actualizar a clientes el Tipo de cliente " + descrTipoCliente
    let imgIcon = "images/archivo_32.png"

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input

    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large plus yellow icon"></i>
            Procesar archivo
        </button>
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listArchivo, this.props.empresa.empresaArchFE):()=>{}}>
              <div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <h1 style={{color: '#2C7744'}}>Procesar archivo para ACTUALIZAR Tipo de cliente</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>

                <br/>
                
                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={this.props.styles.boxGrid}>
                        <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>Tipo de cliente</label>
                        <ListaTipo list={lista} styles={this.props.styles} handleChange={this.handleChange}/>
                      </div>
                    </div>
                  </div>
                </Form.Field>
                <hr></hr>

                <br/>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Seleccionar archivo CSV...&nbsp;&nbsp;
                      </label>

                      <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                      {/* <output id="out" style={estilos1}>
                          file contents will appear here
                      </output> */}
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                          <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                  name="checkTieneEncab" onChange={this.handleChange}/>
                          &nbsp;&nbsp;Tiene encabezados en la primera fila
                        </p>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <br/>
                <hr></hr>


                <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Totales:  Clientes:&nbsp;
                  {listArchivo.length}
                </p>

                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '100%'}}>
                      <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                    </div>
                  </div>
                </div>
                <hr></hr>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
                <div style={{height: '40em', overflow: 'auto'}}>
                  <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                      <th className=''>No.</th>  
                      <th className=''>Contrato</th>
                      </tr>
                    </thead>
                    <ListaClientes list={listArchivo}/>
                  </table>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),

  graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),
)(ProcAdmTC)
